var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378 512",
    width: 378,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business-report-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m2.6 2.1l-2.6 2v181.5c0 180.1 0 181.4 2 183.4 2.5 2.5 7.1 2.6 10.1 0.1l2.4-1.9 0.3-176.1 0.2-176.1h174 174v24.4c0 24.2 0 24.5 2.3 27.2 3.1 3.5 8.2 3.8 10.9 0.5 1.7-2.1 1.8-4.7 1.8-32.6v-30.4l-2.6-2-2.7-2.1h-183.7-183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m190.3 32.3l82.9 0.2 1.9 2.4c1.7 2.1 1.9 4.1 1.9 21.1 0 17-0.2 19-1.9 21.1l-1.9 2.4h-168.4l-1.9-2.4c-1.7-2.1-1.9-4.1-1.9-21.6 0-20.3 0.2-21 5-22.8 0.8-0.3 38.8-0.5 84.3-0.4zm71.7 14.7h-146v18h146z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m365.4 92.1c-1.9 2.1-1.9 7.1-2.2 203.5l-0.2 201.4h-174-174v-50.1-50.1l-2.9-2.9c-3.5-3.4-5.9-3.6-9.5-0.8l-2.6 2v56.4 56.4l2.6 2 2.7 2.1h183.7 183.7l2.7-2.1 2.6-2v-207c0-205.6 0-206.9-2-208.9-2.7-2.7-8.1-2.6-10.6 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m115.7 104.1c9.2 4.4 21.6 16.7 26.1 26.1 8 16.5 8 34.7 0.1 51.4-4.6 9.6-16.8 21.9-26.2 26.3-16.7 7.9-34.7 7.9-51.3 0-9.4-4.5-21.7-16.8-26.2-26.1-5.9-12.1-7.5-25-4.7-38.1 2.3-11.1 6.9-19.2 16-28.2 8.9-9 17.1-13.7 27.8-16 12.9-2.8 26.2-1.2 38.4 4.6zm-41.8 12.3c-7 2.8-10.4 5.2-15.8 11.1-15.5 16.8-14.2 44.1 2.7 59.6 13.7 12.6 32 15.2 48.7 7 10.4-5.1 20-17.2 22.1-27.9l0.7-3.2h-23c-21 0-23.1-0.2-24.6-1.8-1.5-1.6-1.7-4.8-1.7-24.5 0-25.9 0.7-24.4-9.1-20.3zm26.9-2l-2.8-0.6v34.2h34.2l-0.7-2.8c-2.6-10.8-11.9-22.3-21.9-27.2-3.4-1.6-7.3-3.2-8.8-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m184.2 100c-1.4 1.4-2.2 3.3-2.2 5.5 0 2.2 0.8 4.1 2.2 5.5 2.2 2 3.1 2 79.5 2h77.4l2.4-2.5c1.4-1.3 2.5-3.6 2.5-5 0-1.4-1.1-3.7-2.5-5l-2.4-2.5h-77.4c-76.4 0-77.3 0-79.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m184.2 133.6c-3 2.1-3.1 8.3-0.1 11 2 1.8 5 1.9 77.8 2.2 41.6 0.1 76.6 0 77.9-0.3 3.2-0.8 6.2-4.1 6.2-6.9 0-1.3-0.9-3.5-2.1-5l-2-2.6h-77.8c-68.7 0-77.9 0.2-79.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m187 165.7c-3.3 1.2-5 3.7-5 7.4 0 7.3-4.9 6.9 82.1 6.9h77.8l2-2.6c3.4-4.3 2.6-8.6-2-10.9-2.4-1.3-13.9-1.5-78.1-1.4-41.4 0-76 0.3-76.8 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m184.2 201c-1.4 1.4-2.2 3.3-2.2 5.5 0 2.2 0.8 4.1 2.2 5.5 2.1 2 3.3 2 49.3 2h47.2l2.1-2.3c2.9-3.1 2.9-7.7-0.1-10.5-2.3-2.2-2.4-2.2-49.3-2.2-45.9 0-47.1 0-49.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m47.1 251.6c-2.7 3.5-2.6 5.7 0.3 9.1l2.4 2.8h71c68.4 0 71.1-0.1 73.1-1.9 2.7-2.5 2.9-8.6 0.3-10.9-1.7-1.6-8.2-1.7-73.5-1.7h-71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m49.3 283c-4.7 1.9-5.6 7.8-1.8 11.5l2.4 2.5h71.1c69.7 0 71 0 73-2 3-3 2.7-8.3-0.6-10.9-2.6-2.1-3.3-2.1-72.3-2-38.3 0-70.6 0.4-71.8 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m281.1 284.9c-1.1 1.1-2.3 3.5-2.6 5.3-0.3 1.8-0.5 44.1-0.3 94l0.3 90.7 2.3 2.3c2.2 2.3 2.8 2.3 27.5 2.6 13.8 0.2 26.2 0 27.5-0.3 1.2-0.3 3.1-1.4 4.2-2.5 1.9-1.9 2-3.6 2-64.4 0-34.3-0.3-63.2-0.6-64.1-1-2.4-6-4.6-8.9-3.9-5.6 1.4-5.5-0.1-5.5 62.6v57.8l-16.7-0.2-16.8-0.3-0.3-83.3-0.2-83.2h17 17v10.8c0 10 0.2 11 2.3 13 3.3 3.1 8 2.9 10.6-0.4 1.9-2.4 2.1-4 2.1-18.1 0-15-0.1-15.5-2.5-17.8l-2.4-2.5h-27.1c-25.4 0-27.1 0.1-28.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m47.5 318.5c-3 2.9-3.2 6.4-0.6 9.6l1.9 2.4 41.1 0.3 41.1 0.3 2.5-2.5c3.2-3.2 3.2-7 0-10.1l-2.4-2.5h-40.6-40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m230.3 323.2l26.9 0.3 1.9 2.4c1.8 2.2 1.9 5 1.9 75.6 0 70.7-0.1 73.4-1.9 75.6l-1.9 2.4h-27.5c-25.6 0-27.6-0.1-29.6-1.9-2.1-1.9-2.1-1.9-2.1-76.2v-74.3l2.7-2.1c2.6-2 3.5-2.1 29.6-1.8zm15.7 14.8h-33v127h33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m148.5 384c25.9 0 27.2 0.1 29.3 2 2.2 2.1 2.2 2.1 2.2 45.9 0 43.2 0 43.8-2.1 45.7-2 1.8-4 1.9-29.6 1.9h-27.5l-1.9-2.4c-1.8-2.2-1.9-4.5-1.9-45.4 0-42.8 0-43.1 2.2-45.4 2.1-2.3 2.2-2.3 29.3-2.3zm16.5 15h-33v66h33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m68.7 432.3c33.8 0.3 30.8-2 30.8 23.7 0 25.7 2.8 23.4-29.8 23.8-13.8 0.2-26.2 0-27.5-0.3-1.2-0.3-3.1-1.4-4.2-2.5-1.9-1.9-2-3.4-2-20.8 0-19.6 0.2-20.7 4.5-23.1 1.4-0.7 10.3-1 28.2-0.8zm15.8 15.2l-16.7-0.3-16.8-0.2v18l16.8-0.2 16.7-0.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.f688488639dc56fd40864a1798408cee.svg";
export { ForwardRef as ReactComponent };